import { PAGINEDETAIL, TEMI } from 'utils/endpoint'

import Breadcrumbs from 'components/atomic/Breadcrumbs'
import Link from 'next/link'
import MetaSeo from 'components/atomic/MetaSeo'
import TemaCard from 'components/card/TemaCard'
import Trans from 'components/atomic/Trans'
import { api } from 'utils'
import Head from 'next/head'

const TemiPrincipali = ({ temi, pagina }) => {
  return (
    <>
      <MetaSeo seo={pagina.seo} />
      <main className="temi-page">
        <div className="w-container">
          <Breadcrumbs breadcrumbs={pagina.breadcrumbs} />

          <section className="temi-page__header">
            {pagina.main_image ? (
              <>
                <Head>
                  <link rel="preload" href={pagina.main_image} as="image" />
                </Head>
                <img
                  src={pagina.main_image}
                  alt={pagina.titolo?.toAltTitle()}
                  title={pagina.titolo?.toAltTitle()}
                  className="temi-page__image"
                />
              </>
            ) : null}

            <h1 className="temi-page__header__title heading1">{pagina.titolo}</h1>

            {pagina.descrizione ? (
              <p className="temi-page__header__abstract">{pagina.descrizione}</p>
            ) : null}
          </section>

          <section className="temi-page__all">
            <Link legacyBehavior href="/temi/tutti">
              <a className="button button--primary">
                <Trans chiave="temi-page__all Vedi tutti i temi" />
              </a>
            </Link>
          </section>

          <section className="temi-page__list row">
            {temi.map((tema) => (
              <TemaCard key={tema.id} tema={tema} />
            ))}
          </section>

          <section className="temi-page__all">
            <Link legacyBehavior href="/temi/tutti">
              <a className="button button--primary">
                <Trans chiave="temi-all-page__all Vedi tutti i temi" />
              </a>
            </Link>
          </section>
        </div>
      </main>
    </>
  )
}

export const getStaticProps = async () => {
  const PRINCIPALI = '?principale=true'
  const response = await api.get(`${TEMI}${PRINCIPALI}`)
  const temi = response.data

  const pageResponse = await api.get(PAGINEDETAIL, {
    params: {
      chiave: 'temi-principali',
    },
  })
  const pagina = await pageResponse.data

  const toolbarProps = { toolbarPage: pagina }

  return { props: { temi, pagina, ...toolbarProps }, revalidate: 60 * 2 }
}

export default TemiPrincipali
